export default __webpack_public_path__ + "static/media/home_explain_multi_dataset@2x.aaca3407.png";